<template>
    <div class="d-flex flex-wrap">
        <v-icon v-if="mapping" size="small" :title="$t(mapping.title)">
            {{ mapping.ico }}
        </v-icon>
        <v-chip v-else size="x-small" class="mr-1 mt-1" v-text="groupName" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {popularServicesMapping} from '@/utils/hotels/hotel-transformers'

    //TODO Make mapping on api response transform for size optimization

    @Component
    export class HotelServiceIcon extends Vue {
        @Prop() groupName
        @Prop() map

        get mapping() {
            const serviceWithCode = this.map.find(e => e.name === this.groupName)
            if (serviceWithCode) {
                return popularServicesMapping[serviceWithCode.otaCode]
            } else {
                return false
            }
        }
    }

    export default HotelServiceIcon
</script>
